export default function validate(newUserObject) {
  const fieldErrorsObj = {};
  const fieldsHelperTextObj = {};

  // Takes the newUser state object as an argument which is just a user object with all the fields and associated values

  // loop through the properties and for each one, run the respective validation function, if it fails validation, return the appropriate error message for its field name in the fieldErrors object
  Object.keys(newUserObject).forEach((key) => {
    const validation = handleValidation(key, newUserObject[key]);

    if (!validation) {
      // if validation = false, just make sure the error for that field in the field errors object is set to false
      return;
    }
    // otherwise set the fieldErrors to true for that field, and set the helperText for that field equal to the value returned from the validation function
    fieldErrorsObj[key] = true;
    fieldsHelperTextObj[key] = validation;
  });

  if (newUserObject.newPassword !== newUserObject.confirmNewPassword) {
    fieldErrorsObj.confirmNewPassword = true;
    fieldsHelperTextObj.confirmNewPassword = 'Passwords do not match.';
  }

  return [fieldErrorsObj, fieldsHelperTextObj];

  /** **************************************** FIELD VALIDATION FUNCTIONS ****************************************************************** */

  function handleValidation(fieldName, value) {
    switch (fieldName) {
      case 'oldPassword':
        return oldPassword(value);
      case 'newPassword':
        return newPassword(value);
      case 'confirmNewPassword':
        return confirmNewPassword(value);
      default:
        return false;
    }
  }

  function oldPassword(value) {
    if (!value) {
      return 'Old Password is required.';
    }
    return false;
  }

  function newPassword(value) {
    if (!value) {
      return 'New Password is required.';
    }
    return false;
  }

  function confirmNewPassword(value) {
    if (!value) {
      return 'You need to confirm your new password.';
    }
    return false;
  }
}
